module.exports = "<div class=\"video-background\">\n  <div class=\"video-background__placeholder\" [class.active]=\"showPlayer\"></div>\n  <div class=\"video-background__pattern\" [class.active]=\"showPlayer\"></div>\n\n  <youtube-player class=\"video-foreground\" [videoId]=\"id\" (ready)=\"savePlayer($event)\" (change)=\"onStateChange($event)\"\n    [playerVars]=\"playerVars\"></youtube-player>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/components/video-background/video-background.component.html
// module id = ./src/app/view/components/video-background/video-background.component.html
// module chunks = main